import { useEffect, useRef, useState } from 'react';
import { ERRORS } from '../../constants/AppConstants';
import getCroppedImage from '../../Util/getCroppedImage';
import IconCropper from '../IconCropper/iconCropper';


const CustomContentForm = ({
    title,
    setTitle,
    titleColor,
    setTitleColor,
    message,
    setMessage,
    messageColor,
    setMessageColor,
    allowBtnTex,
    setAllowBtnText,
    allowBtnTextColor,
    setAllowBtnTextColor,
    allowBtnColor,
    setAllowBtnColor,
    denyBtnText,
    setDenyBtnText,
    denyBtnTextColor,
    setDenyBtnTextColor,
    denyBtnColor,
    setDenyBtnColor,
    background,
    setBackground,
    selectedDesign,
    iconPath,
    iconName,
    setIconPath,
    setIconName,
    setPromptIcon,
    prompt,
    isDiscarded,
    setIsDiscarded,
    setDefaultIcons,
    setIsDirty,

    titleError,
    messageError,
    allowTextError,
    denyTextError,
    setTitleError,
    setMessageError,
    setAllowTextError,
    setDenyTextError,
    setDisplayIconPath,
    displayIconPath,
}) => {
    
    useEffect(() => {
        if(isDiscarded) {
            setTitleError(null);
            setMessageError(null);
            setAllowTextError(null);
            setDenyTextError(null);
            setIsDiscarded(false);
        }
    }, [isDiscarded])

    const iconRef = useRef(null);

    const [openCropper, setOpenCropper] = useState(false);

    const handelTitleValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <= 0 ) {
            setTitleError(ERRORS.PERMISSION_PROMPT_ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        if(value.trim().length <= 50) {
            setTitle(value);
        }
        
    }

    const handelMessageValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <= 0 ) {
            setMessageError(ERRORS.PERMISSION_PROMPT_ERRORS.MESSAGE_REQUIRED);
        }
        else {
            setMessageError(null);
        }
        if(value.trim().length <= 150) {
            setMessage(value);
        }
        
    }

    const handelAllowBTNValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <= 0 ) {
            setAllowTextError(ERRORS.PERMISSION_PROMPT_ERRORS.ALLOW_TEXT_REQUIRED);
        }
        else {
            setAllowTextError(null);
        }
        if(value.trim().length <= 10) {
            setAllowBtnText(value);
        }
        
    }

    const handelDenyBTNValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <= 0 ) {
            setDenyTextError(ERRORS.PERMISSION_PROMPT_ERRORS.DENY_TEXT_REQUIRED);
        }
        else {
            setDenyTextError(null);
        }
        if(value.trim().length <= 10) {
            setDenyBtnText(value);
        }
        
    }
    
    const handelFileUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setIconName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);
            iconRef.current.value = '';
            setIsDirty(true);
        }
    });

    const onCancelCrop = () => {
        setDefaultIcons();
        setOpenCropper(false);
        setDisplayIconPath('');
    }

    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            iconPath,
            croppedAreaPixel,
            0,
            iconName,
        );
        setIconPath(url);
        setDisplayIconPath(url);
        setPromptIcon(file);
        setOpenCropper(false);
    }

    const onClearIcon = () => {
        setPromptIcon(null);
        setIconPath('');
        setIconName('');
        setDisplayIconPath('');
        setIsDirty(true);
    }

    return <>
        {
            prompt !== 'gdpr' && <div className="form-group">                   
                <label className="form-label text-dark regular full-width">Title<span className="float-right">{title.length} / 50</span></label>
                <div className="d-flex">
                    <textarea 
                        type="text" 
                        rows="3" 
                        className="form-control" 
                        value={title} 
                        onChange={({target}) => handelTitleValidation(target.value)}
                        maxLength={50}
                        >
                    </textarea>
                    <input type="color" className="form-control ml-2" value={titleColor} onChange={({target}) => setTitleColor(target.value)} />
                </div>
                {titleError && <span className="error-message">{titleError}</span>}                                                        
            </div>
        }
        <div className="form-group">                   
            <label className="form-label text-dark regular full-width">Message<span className="float-right">{message.length} / 150</span></label>
            <div className="d-flex">
                <textarea 
                    type="text" 
                    rows="3" 
                    className="form-control" 
                    value={message}  
                    onChange={({target}) => handelMessageValidation(target.value)}
                    maxLength={150}
                    >
                </textarea>
                <input type="color" className="form-control ml-2" value={messageColor} onChange={({target}) => setMessageColor(target.value)} />
            </div>
            {messageError && <span className="error-message">{messageError}</span>}                                                           
        </div>   
        {
            (selectedDesign !== 'CM' && selectedDesign !== 'FS' && prompt !== 'gdpr') &&   <div className="form-group">
            <label className="medium">Icon</label>
            <div className="d-flex">                                                        
                <div className="form-group mb-0">  
                    <div className="d-flex align-items-center">
                        <div className="file-upload">                        
                            <input 
                                type="file" 
                                accept="image/*"
                                onChange={(event) => handelFileUpload(event)}    
                                ref={iconRef}
                            />
                            <i className="icon icon-file"></i>
                            Select File                                
                        </div>
                        {displayIconPath && <span className="mx-2 image-name">{iconName}</span>}
                        {(displayIconPath) && <button className="btn ml-2 btn-grey" onClick={() => onClearIcon()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                    </div>
                </div>                                                          
                
                
                {/* <button className="btn btn-grey mx-2"><i className="icon icon-search mr-2"></i>Search</button>
                <button className="btn btn-grey"><i className="icon icon-close mr-2"></i>Clear</button> */}
            </div> 
            <span>Note: This image will be used as icon for only this push notification.</span>                                                   
        </div>

        }
        <div className="form-group">                   
            <label className="form-label text-dark regular full-width">'Allow' Button <span className="float-right">{allowBtnTex.length} / 10</span></label>
            <div className="d-flex">
                <input 
                    type="text" 
                    className="form-control" 
                    value={allowBtnTex} 
                    onChange={({target}) => handelAllowBTNValidation(target.value)}
                    maxLength={10}
                />
                <input type="color" className="form-control ml-2" value={allowBtnTextColor} onChange={({target}) => setAllowBtnTextColor(target.value)} />
                <input type="color" className="form-control ml-2" value={allowBtnColor} onChange={({target}) => setAllowBtnColor(target.value)} />
            </div>
            {allowTextError && <span className="error-message">{allowTextError}</span>}                                                               
        </div>
        <div className="form-group">                   
            <label className="form-label text-dark regular full-width">'Later' Button <span className="float-right">{denyBtnText.length} / 10</span></label>
            <div className="d-flex">
                <input 
                    type="text" 
                    className="form-control" 
                    value={denyBtnText} 
                    onChange={({target}) => handelDenyBTNValidation(target.value)}
                    maxLength={10}
                />
                <input type="color" className="form-control ml-2" value={denyBtnTextColor} onChange={({target}) => setDenyBtnTextColor(target.value)} />
                <input type="color" className="form-control ml-2" value={denyBtnColor} onChange={({target}) => setDenyBtnColor(target.value)} />
            </div>    
            {denyTextError && <span className="error-message">{denyTextError}</span>}                                                         
        </div> 
        <div className="d-flex justify-content-between">
            <label>Background</label>
            <input type="color" className="form-control ml-2" value={background} onChange={({target}) => setBackground(target.value)} />
        </div>

        <IconCropper
            open={openCropper} 
            onClose={onCancelCrop} 
            url={iconPath} 
            onSave={getCroppedIcon} 
        />
    </>
};


export default CustomContentForm;